import { render } from "./Sample.vue?vue&type=template&id=50357732&scoped=true"
import script from "./Sample.vue?vue&type=script&lang=js"
export * from "./Sample.vue?vue&type=script&lang=js"

import "./Sample.vue?vue&type=style&index=0&id=50357732&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50357732"]])

export default __exports__